// @flow
/* eslint max-len: ["error", { "ignoreStrings": true }] */
import * as React from 'react';

type Props = {|
  color?: string,
  width?: number,
  reverse?: boolean,
|};

export default function ChatUIBubble({ color = '#efefef', width = 500, reverse = false }: Props) {
  const dPath = reverse
    ? 'M49.33871,98.67741A49.33871,49.33871,0,0,1,49.33871,0h81.32258a49.33871,49.33871,0,0,1,0,98.67742H104.34757l3.17049,12.02761c.64946,1.2671-1.29892,2.53419-2.59784,1.90064L76.22791,98.67741Z'
    : 'M103.77209,98.67741,75.07978,112.60566c-1.29892.63355-3.2473-.63354-2.59784-1.90064l3.17049-12.02761H49.33871A49.33871,49.33871,0,0,1,49.33871,0h81.32258a49.33871,49.33871,0,0,1,0,98.67742Z';
  return (
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 113" width={width}>
      <g>
        <g>
          <g>
            <path d={dPath} fill={color} />
          </g>
        </g>
      </g>
    </svg>
  );
}
